import { Icon } from "@material-ui/core";
import i18n from "i18next";
import { TemplateFilter } from "Models/Filters/TemplateFilter";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IChecklistTemplateAction } from "Store/ChecklistTemplates/ChecklistTemplateAction";
import { IChecklistTemplateState } from "Store/ChecklistTemplates/ChecklistTemplateState";
import { IApplicationState } from "Store/Store";
import styles from "./ChecklistTemplateSearch.scss";

const checklistTemplateAction = ServiceProvider.get<IChecklistTemplateAction>(Types.IChecklistTemplateAction);

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getChecklistTemplatesByFilterAsync: (filter: TemplateFilter) =>
        dispatch(checklistTemplateAction.getChecklistTemplatesByFilterAsync(filter, true))
});

const mapStateToProps = (state: IApplicationState) => ({
    checklistTemplateState: state.checklistTemplateState
});

interface IProps {
    checklistTemplateState: IChecklistTemplateState;
    getChecklistTemplatesByFilterAsync: (filter: TemplateFilter) => Action;
}

interface IState {
    checklistTemplateState: IChecklistTemplateState;
    query: string;
}

export class ChecklistTemplateSearch extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    private DEBOUNCE_TIMEOUT: number = 500;

    constructor(props: IProps) {
        super(props);

        const currentFilter = props.checklistTemplateState.currentFilter;
        this.state = {
            checklistTemplateState: props.checklistTemplateState,
            query: currentFilter && currentFilter.query ? props.checklistTemplateState.currentFilter.query : ""
        };

        this.clearQuery = this.clearQuery.bind(this);
        this.findChecklistTemplates = this.findChecklistTemplates.bind(this);
        this.filterNewQuery = this.filterNewQuery.bind(this);
    }

    public clearQuery() {
        this.filterNewQuery("");
    }

    public findChecklistTemplates(event: React.FormEvent<HTMLInputElement>) {
        const newQuery = event.currentTarget.value;
        this.filterNewQuery(newQuery);
    }

    private filterNewQuery(newQuery: string) {
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }
        this.setState({ query: newQuery });

        const debounceFunction = () => {
            const filter = {
                ...this.state.checklistTemplateState.currentFilter,
                query: newQuery,
                skip: 0
            };
            this.props.getChecklistTemplatesByFilterAsync(filter);
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), this.DEBOUNCE_TIMEOUT);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState | null> {
        if (nextProps.checklistTemplateState !== prevState.checklistTemplateState) {
            return { checklistTemplateState: nextProps.checklistTemplateState };
        }
        return null;
    }

    public render() {
        return (
            <div className={styles.searchWrapper}>
                <div className={styles.icon}>
                    <Icon>search</Icon>
                </div>
                <input id="checklist-searchbox" className={styles.search} type="text" placeholder={i18n.t("checklists.search.placeholder")} value={this.state.query} onChange={this.findChecklistTemplates} />
                {this.state.query !== "" ? <div className={styles.clear} onClick={this.clearQuery}>X</div> : null}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistTemplateSearch);


// WEBPACK FOOTER //
// ./src/Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateSearch/ChecklistTemplateSearch.tsx